import { v4 } from 'uuid';

import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiHelperService } from '../../core/api-helper.service';
import { RegistrationForm } from './registration-form.model';
import { ErrorContext, OnDialogCloseEnum, ServerError } from '../errors/error.model';


class RegistrationSubmissionError extends ServerError {
    constructor(msg: string, ctx?: ErrorContext) {
        super(msg, ctx);
        this.ctx.userMessage = 'We had trouble submitting your registration. Support has been notified.';
        // TODO (jacob): I'm not confident we need to do this.
        this.onDialogClose = OnDialogCloseEnum.LOGOUT;
    }
}
@Injectable({
    providedIn: 'root'
})
export class RegistrationFormService {

    options = { setRoot: true, authenticate: true };
    constructor( private apiHelper: ApiHelperService) { }

    saveRegistrationForm(data): Promise<{ email:string, temp_password: string }> {
        const newObj = {
            approved: false,
            completed: false,
            transitioned: false,
            ...data
        };

        const options = { setRoot: true };
        const request = ((newObj.isFreeTrialAccount)
            ? this.apiHelper.apiCallSane(
                '/anon/registration-form/new-trial',
                'POST',
                this.apiHelper.getDefaultHeaders(),
                null,
                newObj,
                options)
            : this.apiHelper.apiCallSane(
                '/anon/registration-form/new',
                'POST',
                this.apiHelper.getDefaultHeaders(),
                null,
                newObj,
                options))
        .catch(e => { throw RegistrationSubmissionError.upgrade(e) });


        return request as Promise<{ email:string, temp_password: string }>;

    }

    getRegistrationForms() {
        return this.apiHelper.apiCallSane(
            '/registration-forms',
            'GET',
            this.apiHelper.getDefaultHeaders(),
            { transitioned: false },
            null,
            this.options);
    }

    approveRegistration(id: string): Promise<RegistrationForm> {
        return this.apiHelper.apiCallSane(
            '/registration-form/approve',
            'PUT',
            this.apiHelper.getDefaultHeaders(),
            { id },
            null,
            this.options);
    }

    resendAccountSetupEmail(userUid: string, userEmail: string, isFreeTrial = false): Promise<void> {
        const body = {
            userUid,
            userEmail,
            isFreeTrial
        };
        const headers: HttpHeaders = this.apiHelper.getDefaultHeaders();
        return  this.apiHelper.apiCallSane('/registration-form/resendAccountSetupEmail', 'POST', headers, null, body);
    }
}

